import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';

class Page extends Component {
  render() {
    const { classes, children } = this.props;
    return <div className={classes.page}>{children}</div>;
  }
}

const styles = () => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 0',
    overflow: 'hidden',
  },
});

export default withStyles(styles)(Page);
